import HttpService from '../../services/HttpService';
import ErrorSwitchCase from '../../services/ErrorHandlerService';
import { ADMIN_PATH } from '../../url';
const _axios = HttpService.getAxiosClient();

export const getDesignations = async () => {
  try {
    const response = await _axios.get(`${ADMIN_PATH}/designations`);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
export const postDesignations = async (itemsList) => {
  try {
    const response = await _axios.post(`${ADMIN_PATH}/designations`, {
      designationNames: itemsList,
    });
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
export const deleteDesignation = async (designationName) => {
  try {
    const response = await _axios.delete(
      `${ADMIN_PATH}/designations/${designationName}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getOfficeLocations = async () => {
  try {
    const response = await _axios.get(`${ADMIN_PATH}/office-location`);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error?.response?.data);
  }
};

export const getLeaveGroups = async (isActive) => {
  try {
    const query = isActive === undefined ? '' : `?isActive=${isActive}`;
    const response = await _axios.get(`${ADMIN_PATH}/leave-group${query}`);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error?.response?.data);
  }
};

export const createLeaveGroup = async (leaveGroup) => {
  try {
    const response = await _axios.post(`${ADMIN_PATH}/leave-group`, leaveGroup);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error?.response?.data);
  }
};

export const updateLeaveGroup = async (leaveGroup) => {
  try {
    const response = await _axios.put(`${ADMIN_PATH}/leave-group`, leaveGroup);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error?.response?.data);
  }
};

/**
 * QA/admin: grant current calendar quarter to all eligible employees.
 * Production authorization of this action is still pending confirmation.
 * Individual employee grant is not exposed.
 */
export const grantCurrentQuarterlyLeaveForAllEmployees = async () => {
  try {
    const response = await _axios.post(
      `${ADMIN_PATH}/quarterly-leave-distribution/grant-all-current`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error?.response?.data);
  }
};

export const getSkills = async () => {
  try {
    const response = await _axios.get(`${ADMIN_PATH}/skills`);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error);
  }
};
export const postSkills = async (itemsList) => {
  try {
    const response = await _axios.post(`${ADMIN_PATH}/skills`, [itemsList]);
    return ErrorSwitchCase(response);
  } catch (error) {
    console.log(error);
    return ErrorSwitchCase(error.response.data);
  }
};
export const deleteSkill = async (skillName) => {
  try {
    const response = await _axios.delete(`${ADMIN_PATH}/skills/${skillName}`);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getHolidays = async (officeLocationId, startDate, endDate) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/getHoliday/${officeLocationId}?${
        startDate ? 'startDate=' + startDate : ''
      }${endDate ? '&endDate=' + endDate : ''}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const saveHolidays = async (holiday, officeLocationId) => {
  try {
    const response = await _axios.post(
      `${ADMIN_PATH}/addHoliday/${officeLocationId}`,
      holiday,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
export const updateHolidayById = async (holiday) => {
  try {
    const response = await _axios.put(`${ADMIN_PATH}/updateHoliday`, holiday);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
export const deleteHolidayById = async (holidayId) => {
  try {
    const response = await _axios.delete(
      `${ADMIN_PATH}/deleteHoliday/${holidayId}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getLeaveTypes = async (year) => {
  try {
    const response = await _axios.get(`${ADMIN_PATH}/leave?year=${year}`);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
export const saveLeaveType = async (leaveType) => {
  try {
    const response = await _axios.post(`${ADMIN_PATH}/leave`, leaveType);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
export const updateLeaveTypeById = async (leaveType) => {
  try {
    const response = await _axios.put(`${ADMIN_PATH}/leave`, leaveType);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
export const deleteLeaveTypeById = async (leaveTypeId, year) => {
  try {
    const response = await _axios.delete(
      `${ADMIN_PATH}/leave?id=${leaveTypeId}&year=${year}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
export const updateEmployeeRole = async (empDetail) => {
  try {
    const response = await _axios.put(
      `${ADMIN_PATH}/employee/update-employee`,
      empDetail,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
